import { Responsive } from '@cian/ui-kit';
import { FC } from 'react';

import { Advantages } from 'shared/components/Advantages';
import { Button } from 'shared/components/Button';

interface IAdvantagesContainerProps {
  url: string;
  onClick: (buttonName: string) => void;
}

export const AdvantagesContainer: FC<IAdvantagesContainerProps> = ({ url, onClick }) => {
  return (
    <>
      <Advantages />
      <Responsive phone>
        <Button onClick={onClick} url={url} />
      </Responsive>
    </>
  );
};
